import { useState } from "react";

import RatingIcon from "components/feedback/form/ratings/icon";

const ratingsNo = 5;

interface RatingsProps {
  onSelect: (index: number) => void;
  minRating: number;
}

const Ratings = ({ onSelect, minRating }: RatingsProps) => {
  const [ratings, setRatings] = useState(minRating);

  return (
    <div>
      {Array.from(Array(ratingsNo), (i, j) => {
        return (
          <RatingIcon
            minRating={minRating}
            index={j}
            key={j}
            isActive={ratings > j}
            onSelect={(index) => {
              setRatings(index);
              onSelect(index);
            }}
          />
        );
      })}
    </div>
  );
};

export default Ratings;
